/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
// import AddToHomescreen from 'react-add-to-homescreen';
import { Component, Fragment } from "react";
import { BrowserRouter, HashRouter, Route, Switch, Redirect } from "react-router-dom";
import Notification, { notify } from 'react-notify-toast';
import { ScrollToTop } from 'Components';
import './App.scss';
import { Http, API, Utils, Auth, Constant, _ } from "Helpers";
import { Layout } from "Pages";
import { ReduxHOC } from "HOC";
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
const location = history.location;
const queryString = require('query-string');
const parsed = queryString.parse(location.search);

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      AppInit: false,
      Cookies: undefined,
      layoutPosting:false
    }
  }
  componentDidMount() {

    if (Auth.getAuth() && Utils.getLangPosting()) {
      Http.post(API.UPDATE_LANG).then(response => {
        localStorage.removeItem('lang_posting');
      })
    }

    Utils.setCpSession()
    this.getSessionKey()

  }

  logout = () => {
    localStorage.clear();
    sessionStorage.clear();
  }


  getSessionKey = () => {
    if (!_.isUndefined(parsed) && !_.isEmpty(parsed)) {
        if(parsed.token.replace("\"", "") !== ''){
          this.authenticate(parsed.token.replace("\"", ""))
        }
      }
  }

  sendMessageToParent = (event) => {
    window.parent.postMessage({ action: event }, '*');
  };

  authenticate = (token) => {
    if(token == 401){
      this.logout()
    } else {
      this.setState({ posting: true });
      const { history } = this.props;

      let param = {
        "token":token,
        "device_type":"3"
      }
  
      Http.post(API.FANTASY_USER_PROFILE, param).then(response => {

        
        if(Auth.getAuth() === response.data.Sessionkey ){
          this.setState({
            AppInit:true,
            layoutPosting:true
          })
        }
        else{
        if(response.response_code == 200){
          Auth.setAuth(response.data.Sessionkey);
          Utils.setProfile(response.data);
        this.setState({
          AppInit:true,
          layoutPosting:true
        },()=>{
          Auth.setAuth(response.data.Sessionkey);
          Utils.setProfile(response.data);
        //  window.location.reload(false);
        if(history){
          history.push(Constant.DASHBOARD_PATH);
        }

        })

        if (window.ReactNativeWebView) {
          let data = {
            action: "login",
            type: 'login',
            targetFunc: "loginFunc",
            userData: response.data
          };
          this.sendMessageToApp(data);
        }
      }
    }
      }).catch(error => {
        this.sendMessageToParent('CLICKED_BACK_BUTTON')
        if (error.data) {

          //window.open(error.data.redirection, "_self")
        }
        this.setState({ posting: false });
        // if(!isGuestUser) {
        // }

      });
    }
  }
 
  render() {
    const {AppInit, layoutPosting} = this.state
    return (
     AppInit ?
              <Fragment>
                <Notification options={{ zIndex: 99999 }} />
                <HashRouter>
                  <ScrollToTop>
                    {layoutPosting && <Switch>
                      <Route exact component={Layout} />
                      <Redirect from="*" to={Constant.DEFAULT_ROOT} />
                    </Switch>}
                  </ScrollToTop>
                </HashRouter>
              </Fragment> : ''
    );
  }
}

export default ReduxHOC(App);